import React from 'react';
import { Badge, Button, Card, FormCheck, Table } from 'react-bootstrap';
import { CollectionReptileGroup, CollectionReptile } from '../collection/types/CollectionTypes.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMars, faVenus, faNeuter, faTimes, faSpinner, IconDefinition, faSortAmountUp, faSortAmountDown, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Placeholder } from 'react-bootstrap';
import { GenderIcon } from './GenderButton.tsx';
import TextTruncate from 'react-text-truncate';


import { GeneText } from './GeneText.tsx';
import { UserInfo } from '../../types/UserInfo.ts';
import { geneExpressions } from '../../types/Gene.ts';

const MorphSexBox = ({
  icon,
  count
}: {
  icon: IconDefinition,
  count: number
}) => {
  return (
    <div className='border px-2 rounded py-1' style={{
      opacity: count === 0 ? .4 : 1
    }}>
      <span>
        <FontAwesomeIcon icon={icon} size="lg" />
      </span>
      <span className='ml-3'>
        {count}
      </span>
    </div>
  )
}


export const CollectionGroup = ({ collectionGroup, selectGroup, selected, selectFunction, isSpecies = false, userInfo }: {
  collectionGroup: CollectionReptileGroup,
  selectGroup?: (name: string) => void,
  selected?: boolean,
  selectFunction?: (group: CollectionReptileGroup) => void | null,
  isSpecies?: boolean,
  userInfo: UserInfo
}) => {
  const hets = collectionGroup.genes?.filter(gene => gene.expression !== "SUPER" && gene.expression !== "NORMAL");
  const expressedGenes = collectionGroup.genes?.filter(gene => gene.expression === "SUPER" || gene.expression === "NORMAL");
  if (!collectionGroup.genes) return null;

  return (
    <div className='col-12 col-md-6 px-0 px-md-3 mb-4'>
      <div
        className={`collection-acc w-100 h-100 d-flex flex-column justify-content-between morph-button mt-4 ${selected ? 'selected-item' : ''}`}
        onClick={() => selectFunction ? selectFunction(collectionGroup) : () => { }}
      >

        <h5 id="morph-name">{collectionGroup.morph_name}</h5>
        <div className='h-100 d-flex flex-column justify-content-between'>
          {!isSpecies &&
            <>
              <div className='mt-2'>
                <h5>Genes</h5>
              </div>
              <div className='row mb-2'>
                <div className='col-6' style={{
                  opacity: expressedGenes.length === 0 ? .4 : 1
                }}>
                  <h6 className='mb-0'>Expressed:</h6>
                  {expressedGenes.length === 0 && <div><small>None</small></div>}
                  <div>{expressedGenes.map(gene => <GeneText gene={gene} />)}</div>
                </div>
                <div className='col-6' style={{
                  opacity: hets.length === 0 ? .4 : 1
                }}>
                  <h6 className='mb-0'>Hets:</h6>
                  {hets.length === 0 && <div><small>None</small></div>}
                  <div>{hets.map(gene => <GeneText gene={gene} />)}</div>
                </div>
              </div>
            </>}
          <div className='d-flex flex-fill flex-column mt-auto'>
            <div className="no-pad d-flex mt-auto mx-auto w-100 flex-row justify-content-around pl-3">
              <MorphSexBox icon={faMars} count={collectionGroup.males} />
              <MorphSexBox icon={faVenus} count={collectionGroup.females} />
              <MorphSexBox icon={faNeuter} count={collectionGroup.unsexed} />
            </div>
          </div>
        </div>
        <div className="text-center mt-3 px-3">
          {selectGroup && <Button className="morph-list-button w-100" variant='outline-light' onClick={(event) => { event.stopPropagation(); selectGroup(collectionGroup.morph_name); }}>Get List</Button>}
        </div>
      </div>
    </div>

  )
}
export const NamedCollectionGroup = (
  {
    group,
    beforeDelete,
    openDetailsModal,
    selectFunction,
    selected,
    deleteMode,
    loading = false,
  }: {
    group: CollectionReptile,
    beforeDelete?: (reptile: CollectionReptile) => void,
    openDetailsModal?: (reptile: CollectionReptile) => void,
    selected?: boolean,
    selectFunction?: (reptile: CollectionReptile) => void | null,
    setDeleteMode?: (deleteMode: boolean) => void,
    deleteMode?: boolean,
    loading?: boolean,
  }) => {

  const singleReptile = group;

  return (
    <div className='col-12 col-md-6'>
      <div
        className={`collection-acc w-100 morph-button mt-4 ${deleteMode ? 'wiggle' : ''}  ${selected && !deleteMode ? 'selected-item' : ''}`}
        onClick={() => selectFunction?.(group)}
      >
        <div className='d-flex flex-fill flex-row justify-content-between'>
          <div className='d-flex flex-column justify-content-start'>
            <h4 id="morph-name" className='text-left mb-2'>{singleReptile.name ? singleReptile.name : singleReptile.morph_name}</h4>
            <div className='text-left'><small>{singleReptile.morph_name}</small></div>
          </div>
          <div className='my-auto'>
            {!deleteMode && <div className="text-center ml-auto my-auto mb-2 px-3">
              <div className='mb-2' >
                <GenderIcon gender={singleReptile.gender} size='lg' withColor />
              </div>
              {loading ? <Button className='button' disabled><FontAwesomeIcon icon={faSpinner} spin /> </Button> : <div className="morph-list-button button" onClick={(event) => { openDetailsModal?.(singleReptile); event.stopPropagation(); }}>View</div>}
            </div>}
            {deleteMode && <div className="text-center ml-auto my-auto mb-2 px-3">
              <div className="button" onClick={() => beforeDelete?.(singleReptile)}>
                <FontAwesomeIcon icon={faTimes} />
              </div>
            </div>}
          </div>
        </div>
      </div>
    </div>
  )
}

export const NamedGroupPlaceholder = () => (
  <div className='col-12 col-md-6'>
    <div className='collection-acc w-100 morph-button mt-4 d-flex' style={{ height: 80, opacity: .65 }}>
      <div className='d-flex flex-fill flex-row justify-content-between'>
        <div className='d-flex flex-column justify-content-start'>
          <Placeholder as='h4' animation="wave" bg="secondary" className='mt-1 text-left mb-2' style={{ width: 200, height: 20 }} />
          <Placeholder as='small' animation="wave" bg="secondary" className='text-left' style={{ width: 100, height: 10 }} />
        </div>
        <div className='my-auto'>
          <Placeholder.Button animation="wave" bg="secondary" className="border-0" style={{ height: 45, width: 53 }} />
        </div>
      </div>
    </div>
  </div>
)

export const CollectionGroupPlaceholder = () => {
  const randExpressedNum = Math.floor(Math.random() * 3) + 1;
  const randHetNum = Math.floor(Math.random() * 2) + 1;
  return <div className='col-12 col-md-6'>
    <div
      className={`collection-acc expand d-flex flex-column justify-content-between morph-button flex-fill w-100 mt-4`}
      style={{ opacity: .65 }}
    >
      <Placeholder as='h3' animation="wave" bg="secondary" className='mt-1 text-left mx-auto mb-2' style={{ width: 240, height: 30 }} />
      <div className='d-flex flex-fill flex-row'>
        <Placeholder as='h5' animation="wave" bg="secondary" className='mt-1 mx-auto text-left mb-2' style={{ width: 75, height: 20 }} />
      </div>
      <div className='d-flex flex-fill flex-row'>
        <div className='d-flex flex-column mx-auto'>
          <Placeholder as='h6' animation="wave" bg="secondary" className='mt-1 mx-auto mb-2' style={{ width: 100, height: 20 }} />
          {Array.from(Array(randExpressedNum).keys()).map(() => (
            <div className='mx-auto'>
              <Placeholder as='h6' animation="wave" bg="secondary" style={{ width: 100, height: 15 }} />
            </div>
          ))}
        </div>
        <div className='d-flex flex-column mx-auto'>
          <Placeholder as='h6' animation="wave" bg="secondary" className='mt-1 mx-auto mb-2' style={{ width: 50, height: 20 }} />
          {Array.from(Array(randHetNum).keys()).map(() => (
            <div className='mx-auto'>
              <Placeholder as='h6' animation="wave" bg="secondary" style={{ width: 100, height: 15 }} />
            </div>
          ))}
        </div>
      </div>
      <div className='d-flex flex-fill flex-row mt-auto'>
        <div className="text-center w-100 mt-auto mb-2 px-3">
          <Placeholder.Button animation="wave" bg="secondary" className="border-0 w-100" style={{ height: 45 }} />
        </div>
      </div>
    </div>
  </div>
}

export const GenderCollectionGroupPlaceholder = ({ sex }: { sex: string }) => (
  <div className='col-12 col-md-6'>

    <div className='collection-acc w-100 morph-button' style={{ opacity: .65 }}>
      <div>
        <Placeholder.Button className={`gender-btn button border-0 ${sex}`} animation="wave" style={{ width: '100%', height: 100 }} />
      </div>
      <div className=" no-pad my-4">
        <div className="no-pad d-flex mx-auto">
          <Placeholder as='h6' animation="wave" className="mx-auto my-0" bg="secondary" style={{ width: 120, height: 20 }} />
        </div>
      </div>
      <div className=" text-center">
        <Placeholder.Button animation="wave" bg="secondary" className="border-0" style={{ height: 45, width: '100%' }} />
      </div>
    </div>
  </div>
)



export const GenderCollectionGroup = ({ collectionGroup, selectGroup }: { collectionGroup: CollectionReptileGroup, selectGroup: (group: string, singularText: string) => void }) => {

  const icon = {
    "males": faMars,
    "females": faVenus,
    "unsexed": faNeuter,
  }
  const singular = {
    "males": "male",
    "females": "female",
    "unsexed": "unsexed",
  }

  return (
    <>
      {Object.keys(icon).map(key => {
        if (collectionGroup[key] === 0) return null;
        return (
          <div className='col-12 col-md-6'>

            <div className="collection-acc w-100 morph-button">
              <div className={`gender-btn button ${singular[key]}`}>
                <FontAwesomeIcon icon={icon[key]} size="5x" />
              </div>
              <div className="right no-pad my-4">
                <div className="no-pad">
                  <h6 className="no-pad columns">Quantity: {collectionGroup[key]}</h6>
                </div>
              </div>
              <div className=" text-center">
                <div className="morph-list-button button" onClick={() => selectGroup(singular[key], singular[key])}>Get List</div>
              </div>
            </div>
          </div>
        )
      }
      )}
    </>
  )
}
export const NoGroupItem = () => {
  return (
    <React.Fragment>
      <div
        className={`collection-acc expand morph-button mt-4 flex-fill`}
      >
        <h3 id="morph-name">No groups found in this section</h3>
        <div className='d-flex flex-fill flex-row'>
          <p>To add animals into your collection click the '+' button in the bottom right corner.</p>
        </div>
      </div>
    </React.Fragment>
  )
}


// sort keys for reptile table
type SORT_KEY = 'name' | 'morph_name' | 'sex';
type SORT_DIRECTION = 'asc' | 'desc';

export const CollectionReptileTable = ({
  reptiles,
  openDetailsModal,
  selectFunction,
  selectedGroups,
  deleteMode,
  beforeDelete,

}: {
  reptiles: CollectionReptile[],
  openDetailsModal?: (reptile: CollectionReptile) => void,
  selectFunction?: (reptile: CollectionReptile) => void | null,
  setDeleteMode?: (deleteMode: boolean) => void,
  selectedGroups: CollectionReptile[],
  deleteMode?: boolean,
  beforeDelete?: (reptile: CollectionReptile) => void,
}) => {
  const [sortKey, setSortKey] = React.useState<SORT_KEY>('name');
  const [sortDirection, setSortDirection] = React.useState<SORT_DIRECTION>('asc');

  const sortedReptiles = React.useMemo(() => {
    return reptiles.sort((a, b) => {
      if (sortKey === 'name') {
        if (!a.name || !b.name) return 0;
        return sortDirection === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
      } else if (sortKey === 'morph_name') {
        return sortDirection === 'asc' ? a.morph_name.localeCompare(b.morph_name) : b.morph_name.localeCompare(a.morph_name)
      } else if (sortKey === 'sex') {
        return sortDirection === 'asc' ? a.gender.localeCompare(b.gender) : b.gender.localeCompare(a.gender)
      }
      return 0;
    })
  }, [reptiles, sortKey, sortDirection])


  return <Table striped bordered hover variant="dark" size='sm' className='mt-3'>
    <thead>
      <tr>
        {selectFunction && <th></th>}
        <th onClick={() => {
          if (sortKey === 'name') {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
          } else {
            setSortKey('name')
            setSortDirection('asc')
          }
        }}>
          Name {sortKey === "name" && <FontAwesomeIcon className='ml-2' icon={sortKey === 'name' ? sortDirection === 'asc' ? faSortAmountUp : faSortAmountDown : faSortAmountUp} />}
        </th>
        <th onClick={() => {
          if (sortKey === 'morph_name') {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
          } else {
            setSortKey('morph_name')
            setSortDirection('asc')
          }
        }}>
          Morph
          {sortKey === "morph_name" && <FontAwesomeIcon className='ml-2' icon={sortKey === 'morph_name' ? sortDirection === 'asc' ? faSortAmountUp : faSortAmountDown : faSortAmountUp} />}
        </th>
        <th onClick={() => {
          if (sortKey === 'sex') {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
          } else {
            setSortKey('sex')
            setSortDirection('asc')
          }
        }}>
          Sex
          {sortKey === "sex" && <FontAwesomeIcon className='ml-2' icon={sortKey === 'sex' ? sortDirection === 'asc' ? faSortAmountUp : faSortAmountDown : faSortAmountUp} />}
        </th>
        <th className='d-none d-md-table-cell'></th>
      </tr>
    </thead>
    <tbody>
      {sortedReptiles.map(reptile => {
        const selected = selectedGroups.some(selected => selected.id === reptile.id)
        return (
          <tr key={reptile.id}>
            {selectFunction && <td>
              <FormCheck className='my-auto p-2 pr-0 mr-3' checked={selected} onChange={() => selectFunction?.(reptile)} />
            </td>}
            <td>{reptile.name}</td>
            <td>{reptile.morph_name}</td>
            <td className='d-none d-md-table-cell'>
              <GenderIcon gender={reptile.gender} withColor />
            </td>
            <td>
              <div className="d-md-none mb-2">
                <GenderIcon gender={reptile.gender} withColor />
              </div>
              {deleteMode ? <Button variant="outline-danger" onClick={() => beforeDelete?.(reptile)}>
                Delete
              </Button> : <Button variant='outline-light' onClick={() => openDetailsModal?.(reptile)}>View</Button>}
            </td>
          </tr>
        )
      })}
    </tbody>
  </Table >
}

export const ListingItem = ({ reptile, openDetailsModal, loading, hideButton = false, editListing }: { reptile: CollectionReptile, openDetailsModal?: (reptile: CollectionReptile) => void, loading?: boolean, hideButton?: boolean, editListing?: (reptile: CollectionReptile) => void }) => {
  // this component is used to display price and image of a reptile in the collection
  return (
    <div className='col-6 col-md-4 col-lg-3 px-2 mb-3'>
      <Card onClick={() => {
        if (openDetailsModal) {
          openDetailsModal(reptile);
        }
      }} 
      style={{ cursor: openDetailsModal ? 'pointer' : 'default'}}
      className='border-dark-subtle border overflow-hidden h-100 listing-card'>
        <div className='card-header-container bg-dark'>
          <Card.Img variant="top" src={reptile.picture || 'images/notavailable.jpg'} style={{
            height: '200px',
            objectFit: 'cover',
            objectPosition: 'center',
          }} />
          <div className="card-btn d-none d-lg-block">
            <Button className='hidden-btn' size='lg' onClick={() => openDetailsModal?.(reptile)} variant='outline-light'>View</Button>
          </div>
        </div>

        <Card.Body className='d-flex flex-column bg-dark text-light'>
          {!loading ? <Card.Title className='d-flex flex-row justify-content-between'><span>{reptile.morph_name || reptile.name}</span> <span className='ml-2'><GenderIcon gender={reptile.gender} withColor /></span> </Card.Title> :
            <Placeholder as={Card.Title} animation="wave">
              <Placeholder xs={10} />
            </Placeholder>}

          {loading && <Placeholder as={Card.Text} animation="wave">
            <Placeholder xs={6} />
          </Placeholder>}

          {reptile.listing_price && <Card.Text>
            ${reptile.listing_price.price}
          </Card.Text>}


          {!loading ? <Card.Text>
            <small>
              <TextTruncate line={3} text={reptile.listing_price?.description} />
            </small>
          </Card.Text> : <small><Placeholder as={Card.Text} animation="wave">
            <Placeholder xs={3} />{' '}
            <Placeholder xs={3} />{' '}
            <Placeholder xs={3} />{' '}
            <Placeholder xs={3} />
            <Placeholder xs={4} />{' '}
            <Placeholder xs={4} />{' '}
            <Placeholder xs={4} />
            <Placeholder xs={7} />{' '}
            <Placeholder xs={3} />{' '}
          </Placeholder> </small>}

          <div className='mt-auto'>
            <div className='flex-wrap mt-3 mb-2 d-none d-md-flex'>
              {reptile.genes.map(gene => (
                <Badge key={gene.id} bg={gene.isHet && gene.expression !== "SUPER" ? 'secondary' : 'primary'} className='mx-1 mb-1'>
                  {gene.isHet ? (geneExpressions.find(g => g.value === gene.expression)?.label ?? '') : ''} {gene.gene_name}
                </Badge>
              ))}
            </div>
            {!hideButton && <div className='mt-auto'>
              {editListing && <Button variant='outline-light' size='sm' className='w-100 mt-2' onClick={(event) => {
                event.stopPropagation();
                editListing(reptile)
                }}>Edit Listing</Button>}
              <div className='d-block d-lg-none'>
                {!loading ? <>
                  <Button variant='outline-light' size='sm' className='w-100 mt-2' onClick={() => openDetailsModal?.(reptile)}>View</Button>
                </>
                  : <Placeholder.Button variant='outline-light' animation="wave" className='w-100 p-3 mt-2' />}
              </div>
            </div>}
          </div>
          {editListing && !reptile.listing_price && !loading && <div className='mt-2 text-warning'>
            <small><FontAwesomeIcon icon={faInfoCircle} /> This animal has no listed price.</small>
          </div>
          }
        </Card.Body>
      </Card>
    </div >
  )
}
